import type { ReactNode } from "react";
import { useLanguageSync } from "./useLanguageSync";

/**
 * Mount once near the top of the React tree, inside the `AuthProvider`.
 * Renders its children unchanged and fires `useLanguageSync()` as a side
 * effect — keeps Customer.io in sync with the user's active UI language
 * across sign-in and any in-app language switches.
 */
export function LanguageSyncInitializer({ children }: { children: ReactNode }) {
  useLanguageSync();
  return <>{children}</>;
}

export default LanguageSyncInitializer;
